import { render } from "./SkillSection.vue?vue&type=template&id=8cd2404c&ts=true"
import script from "./SkillSection.vue?vue&type=script&lang=ts"
export * from "./SkillSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__